
import './TestSpace.css';
import { useEffect, useRef, useState } from 'react';

const python_questions = [
  {
    "question_id": 1,
    "question": "Which keyword is used to define a function in Python?",
    "options": {
      "A": "function",
      "B": "def",
      "C": "fun",
      "D": "define"
    },
    "correct_option": "B"
  },
  {
    "question_id": 2,
    "question": "Which of the following is a valid variable name in Python?",
    "options": {
      "A": "2name",
      "B": "first-name",
      "C": "first_name",
      "D": "class"
    },
    "correct_option": "C"
  },
  {
    "question_id": 3,
    "question": "What is the output of print(type(10))?",
    "options": {
      "A": "<class 'float'>",
      "B": "<class 'int'>",
      "C": "<class 'str'>",
      "D": "<class 'bool'>"
    },
    "correct_option": "B"
  },
  {
    "question_id": 4,
    "question": "Which data type is used to store True or False?",
    "options": {
      "A": "int",
      "B": "str",
      "C": "bool",
      "D": "float"
    },
    "correct_option": "C"
  },
  {
    "question_id": 5,
    "question": "What is the output of print(10 // 3)?",
    "options": {
      "A": "3.33",
      "B": "3",
      "C": "1",
      "D": "4"
    },
    "correct_option": "B"
  },
  {
    "question_id": 6,
    "question": "What is the output of print(2 ** 3)?",
    "options": {
      "A": "6",
      "B": "8",
      "C": "9",
      "D": "5"
    },
    "correct_option": "B"
  },
  {
    "question_id": 7,
    "question": "Which operator checks whether two values are equal?",
    "options": {
      "A": "=",
      "B": "!=",
      "C": "==",
      "D": "==="
    },
    "correct_option": "C"
  },
  {
    "question_id": 8,
    "question": "What is the output of print(10 % 3)?",
    "options": {
      "A": "3",
      "B": "1",
      "C": "0",
      "D": "3.33"
    },
    "correct_option": "B"
  },
  {
    "question_id": 9,
    "question": "Which function converts a value to an integer?",
    "options": {
      "A": "str()",
      "B": "float()",
      "C": "int()",
      "D": "bool()"
    },
    "correct_option": "C"
  },
  {
    "question_id": 10,
    "question": "What is the output of print(bool(0))?",
    "options": {
      "A": "True",
      "B": "False",
      "C": "0",
      "D": "None"
    },
    "correct_option": "B"
  },
  {
    "question_id": 11,
    "question": "Which data type stores an ordered, mutable collection?",
    "options": {
      "A": "tuple",
      "B": "set",
      "C": "list",
      "D": "frozenset"
    },
    "correct_option": "C"
  },
  {
    "question_id": 12,
    "question": "Which collection does not allow duplicate elements?",
    "options": {
      "A": "list",
      "B": "tuple",
      "C": "set",
      "D": "string"
    },
    "correct_option": "C"
  },
  {
    "question_id": 13,
    "question": "Which data type stores key-value pairs?",
    "options": {
      "A": "list",
      "B": "dict",
      "C": "set",
      "D": "int"
    },
    "correct_option": "B"
  },
  {
    "question_id": 14,
    "question": "Which of the following creates a tuple?",
    "options": {
      "A": "[1, 2, 3]",
      "B": "{1, 2, 3}",
      "C": "(1, 2, 3)",
      "D": "{'a': 1}"
    },
    "correct_option": "C"
  },
  {
    "question_id": 15,
    "question": "What is the output of len([10, 20, 30])?",
    "options": {
      "A": "2",
      "B": "3",
      "C": "30",
      "D": "10"
    },
    "correct_option": "B"
  },
  {
    "question_id": 16,
    "question": "Which list method adds an element to the end of a list?",
    "options": {
      "A": "add()",
      "B": "insert_end()",
      "C": "append()",
      "D": "push()"
    },
    "correct_option": "C"
  },
  {
    "question_id": 17,
    "question": "What is the output of print([1, 2, 3][0])?",
    "options": {
      "A": "1",
      "B": "2",
      "C": "3",
      "D": "0"
    },
    "correct_option": "A"
  },
  {
    "question_id": 18,
    "question": "What is the output of print('Python'[1])?",
    "options": {
      "A": "P",
      "B": "y",
      "C": "t",
      "D": "Python"
    },
    "correct_option": "B"
  },
  {
    "question_id": 19,
    "question": "Which string method converts text to lowercase?",
    "options": {
      "A": "lower()",
      "B": "small()",
      "C": "tolower()",
      "D": "case_lower()"
    },
    "correct_option": "A"
  },
  {
    "question_id": 20,
    "question": "What is the output of print('Py' + 'thon')?",
    "options": {
      "A": "Py thon",
      "B": "Python",
      "C": "Py+thon",
      "D": "Error"
    },
    "correct_option": "B"
  },
  {
    "question_id": 21,
    "question": "Which keyword is used for conditional branching?",
    "options": {
      "A": "when",
      "B": "if",
      "C": "check",
      "D": "condition"
    },
    "correct_option": "B"
  },
  {
    "question_id": 22,
    "question": "Which keyword handles an alternative condition when the previous if condition is false?",
    "options": {
      "A": "elseif",
      "B": "else if",
      "C": "elif",
      "D": "otherwise"
    },
    "correct_option": "C"
  },
  {
    "question_id": 23,
    "question": "What is the output of for i in range(3): print(i)?",
    "options": {
      "A": "1 2 3",
      "B": "0 1 2",
      "C": "0 1 2 3",
      "D": "3"
    },
    "correct_option": "B"
  },
  {
    "question_id": 24,
    "question": "How many times does range(5) iterate in a for loop?",
    "options": {
      "A": "4",
      "B": "5",
      "C": "6",
      "D": "1"
    },
    "correct_option": "B"
  },
  {
    "question_id": 25,
    "question": "Which keyword immediately terminates a loop?",
    "options": {
      "A": "stop",
      "B": "exit",
      "C": "break",
      "D": "continue"
    },
    "correct_option": "C"
  },
  {
    "question_id": 26,
    "question": "What does the continue statement do inside a loop?",
    "options": {
      "A": "Terminates the program",
      "B": "Skips to the next iteration",
      "C": "Terminates the loop",
      "D": "Restarts the entire program"
    },
    "correct_option": "B"
  },
  {
    "question_id": 27,
    "question": "Which keyword returns a value from a function?",
    "options": {
      "A": "print",
      "B": "yield_value",
      "C": "return",
      "D": "send"
    },
    "correct_option": "C"
  },
  {
    "question_id": 28,
    "question": "What does a Python function return if it has no return statement?",
    "options": {
      "A": "0",
      "B": "False",
      "C": "None",
      "D": "An empty string"
    },
    "correct_option": "C"
  },
  {
    "question_id": 29,
    "question": "What is the output of def add(a, b): return a + b; print(add(2, 3))?",
    "options": {
      "A": "23",
      "B": "5",
      "C": "None",
      "D": "Error"
    },
    "correct_option": "B"
  },
  {
    "question_id": 30,
    "question": "What is a parameter in a function?",
    "options": {
      "A": "A value printed by the function",
      "B": "A variable defined in the function signature",
      "C": "A Python module",
      "D": "A loop condition"
    },
    "correct_option": "B"
  },
  {
    "question_id": 31,
    "question": "Which keyword is used to create a class in Python?",
    "options": {
      "A": "object",
      "B": "class",
      "C": "struct",
      "D": "new"
    },
    "correct_option": "B"
  },
  {
    "question_id": 32,
    "question": "What is self commonly used for in a Python instance method?",
    "options": {
      "A": "Referencing the current instance",
      "B": "Creating a new class",
      "C": "Importing a module",
      "D": "Ending a function"
    },
    "correct_option": "A"
  },
  {
    "question_id": 33,
    "question": "Which method is commonly used to initialize a new object's instance attributes?",
    "options": {
      "A": "__start__()",
      "B": "__init__()",
      "C": "__create__()",
      "D": "__main__()"
    },
    "correct_option": "B"
  },
  {
    "question_id": 34,
    "question": "What is inheritance in Python?",
    "options": {
      "A": "Copying a variable",
      "B": "A class deriving attributes and methods from another class",
      "C": "Converting a string to an integer",
      "D": "Repeating a loop"
    },
    "correct_option": "B"
  },
  {
    "question_id": 35,
    "question": "Which built-in function returns the type of an object?",
    "options": {
      "A": "kind()",
      "B": "typeof()",
      "C": "type()",
      "D": "object_type()"
    },
    "correct_option": "C"
  },
  {
    "question_id": 36,
    "question": "Which keyword is used to handle exceptions?",
    "options": {
      "A": "catch",
      "B": "except",
      "C": "error",
      "D": "handle"
    },
    "correct_option": "B"
  },
  {
    "question_id": 37,
    "question": "Which exception is raised when dividing a number by zero?",
    "options": {
      "A": "ValueError",
      "B": "TypeError",
      "C": "ZeroDivisionError",
      "D": "NameError"
    },
    "correct_option": "C"
  },
  {
    "question_id": 38,
    "question": "What is the purpose of the finally block?",
    "options": {
      "A": "It runs only when an exception occurs",
      "B": "It runs only when no exception occurs",
      "C": "It normally executes whether or not an exception occurs",
      "D": "It defines a function"
    },
    "correct_option": "C"
  },
  {
    "question_id": 39,
    "question": "Which keyword is used to import a module?",
    "options": {
      "A": "include",
      "B": "using",
      "C": "import",
      "D": "require"
    },
    "correct_option": "C"
  },
  {
    "question_id": 40,
    "question": "What does the len() function return?",
    "options": {
      "A": "The data type",
      "B": "The number of items or length",
      "C": "The memory address",
      "D": "The last element"
    },
    "correct_option": "B"
  },
  {
    "question_id": 41,
    "question": "What is the output of print(5 == 5)?",
    "options": {
      "A": "5",
      "B": "True",
      "C": "False",
      "D": "None"
    },
    "correct_option": "B"
  },
  {
    "question_id": 42,
    "question": "What is the output of print(5 > 10 or 3 < 5)?",
    "options": {
      "A": "True",
      "B": "False",
      "C": "None",
      "D": "Error"
    },
    "correct_option": "A"
  },
  {
    "question_id": 43,
    "question": "Which operator checks whether a value exists in a collection?",
    "options": {
      "A": "has",
      "B": "contains",
      "C": "in",
      "D": "exists"
    },
    "correct_option": "C"
  },
  {
    "question_id": 44,
    "question": "What is the output of print(list(range(2, 6)))?",
    "options": {
      "A": "[2, 3, 4, 5]",
      "B": "[2, 3, 4, 5, 6]",
      "C": "[1, 2, 3, 4, 5]",
      "D": "[3, 4, 5, 6]"
    },
    "correct_option": "A"
  },
  {
    "question_id": 45,
    "question": "Which keyword defines an anonymous function in Python?",
    "options": {
      "A": "anonymous",
      "B": "lambda",
      "C": "def",
      "D": "function"
    },
    "correct_option": "B"
  },
  {
    "question_id": 46,
    "question": "What does the append() method do to a list?",
    "options": {
      "A": "Removes the last element",
      "B": "Adds one element to the end",
      "C": "Sorts all elements",
      "D": "Removes duplicates"
    },
    "correct_option": "B"
  },
  {
    "question_id": 47,
    "question": "Which statement correctly creates an empty dictionary?",
    "options": {
      "A": "[]",
      "B": "()",
      "C": "{}",
      "D": "set()"
    },
    "correct_option": "C"
  },
  {
    "question_id": 48,
    "question": "What is the output of print(10 > 5 and 2 < 1)?",
    "options": {
      "A": "True",
      "B": "False",
      "C": "10",
      "D": "Error"
    },
    "correct_option": "B"
  },
  {
    "question_id": 49,
    "question": "Which statement opens a file in Python?",
    "options": {
      "A": "file.open()",
      "B": "open()",
      "C": "read_file()",
      "D": "start_file()"
    },
    "correct_option": "B"
  },
  {
    "question_id": 50,
    "question": "What is the purpose of the if __name__ == '__main__': statement?",
    "options": {
      "A": "It creates a class",
      "B": "It runs a block when the file is executed as the main program",
      "C": "It imports all modules",
      "D": "It handles exceptions"
    },
    "correct_option": "B"
  }
]


const SCORE_STORAGE_KEY = 'pythonQuizScore';
const ANSWERS_STORAGE_KEY = 'pythonQuizAnswers';
const OPTIONS = ['A', 'B', 'C', 'D'];

const readSavedScore = () => {
  try {
    const storedScore = window.localStorage.getItem(SCORE_STORAGE_KEY);
    const storedAnswers = window.localStorage.getItem(ANSWERS_STORAGE_KEY);
    const score = storedScore === null ? null : Number(storedScore);
    let answers = {};

    if (storedAnswers !== null) {
      try {
        const parsedAnswers = JSON.parse(storedAnswers);
        if (parsedAnswers && typeof parsedAnswers === 'object' && !Array.isArray(parsedAnswers)) {
          answers = Object.fromEntries(
            Object.entries(parsedAnswers).filter(([questionId, option]) => (
              python_questions.some((question) => String(question.question_id) === questionId)
              && OPTIONS.includes(option)
            ))
          );
        }
      } catch {
        answers = {};
      }
    }

    return {
      score: Number.isInteger(score) && score >= 0 && score <= python_questions.length
        ? score
        : null,
      attempted: storedScore !== null,
      answers,
      error: false,
    };
  } catch {
    return { score: null, attempted: false, answers: {}, error: true };
  }
};

const TestSpace = () => {
  const [storageState, setStorageState] = useState(readSavedScore);
  const [answers, setAnswers] = useState(storageState.answers);
  const [result, setResult] = useState(null);
  const [attempted, setAttempted] = useState(storageState.attempted);
  const attemptedRef = useRef(storageState.attempted);
  const answeredCount = Object.keys(answers).length;

  useEffect(() => {
    if (!result) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setResult(null);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [result]);

  const handleAnswerChange = (questionId, option) => {
    setAnswers((currentAnswers) => ({ ...currentAnswers, [questionId]: option }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (attemptedRef.current) return;

    const score = python_questions.reduce(
      (total, question) => total + (answers[question.question_id] === question.correct_option ? 1 : 0),
      0
    );

    attemptedRef.current = true;
    setAttempted(true);
    try {
      window.localStorage.setItem(ANSWERS_STORAGE_KEY, JSON.stringify(answers));
      window.localStorage.setItem(SCORE_STORAGE_KEY, String(score));
      setStorageState({ score, attempted: true, error: false });
      setResult({ score, saved: true });
    } catch {
      setStorageState((currentState) => ({ ...currentState, attempted: true, answers, error: true }));
      setResult({ score, saved: false });
    }
  };

  return (
    <main className="test-space">
      <header className="quiz-header">
        <div className="quiz-heading">
          <span className="quiz-eyebrow">Knowledge check</span>
          <h1>Python fundamentals</h1>
          <p>
            {attempted
              ? 'Your attempt is complete. Review your selections and the correct answers below.'
              : 'Take your time, choose one answer for each question, then submit to see your score.'}
          </p>
        </div>
        <div className="quiz-summary" aria-live="polite">
          <span className="summary-label">Questions answered</span>
          <strong>{answeredCount}<span> / {python_questions.length}</span></strong>
          {storageState.score !== null && (
            <span className="saved-score">Last saved score: {storageState.score} / {python_questions.length}</span>
          )}
          {storageState.error && (
            <span className="storage-warning">Local storage is unavailable. Your latest score may not be saved.</span>
          )}
        </div>
      </header>

      <div
        className="quiz-progress"
        role="progressbar"
        aria-label="Questions answered"
        aria-valuemin="0"
        aria-valuemax={python_questions.length}
        aria-valuenow={answeredCount}
      >
        <span style={{ width: `${(answeredCount / python_questions.length) * 100}%` }} />
      </div>

      <form className="quiz-form" onSubmit={handleSubmit}>
        <div className="questions-list">
          {python_questions.map((question, index) => (
            <fieldset className="question-box" key={question.question_id}>
              <legend className="question-title">
                <span className="question-number">{String(index + 1).padStart(2, '0')}</span>
                <span>{question.question}</span>
              </legend>
              <div className="options-container">
                {Object.entries(question.options).map(([option, answer]) => {
                  const inputId = `question-${question.question_id}-${option}`;
                  const isCorrect = option === question.correct_option;
                  const isSelected = answers[question.question_id] === option;
                  const optionClassName = [
                    'option-box',
                    attempted && isCorrect ? 'is-correct' : '',
                    attempted && isSelected && !isCorrect ? 'is-incorrect' : '',
                  ].filter(Boolean).join(' ');

                  return (
                    <label className={optionClassName} htmlFor={inputId} key={option}>
                      <input
                        id={inputId}
                        type="radio"
                        name={`question-${question.question_id}`}
                        value={option}
                        checked={answers[question.question_id] === option}
                        disabled={attempted}
                        onChange={() => handleAnswerChange(question.question_id, option)}
                      />
                      <span className="option-letter">{option}</span>
                      <span>{answer}</span>
                      {attempted && isCorrect && (
                        <span className="option-feedback">Correct answer</span>
                      )}
                      {attempted && isSelected && !isCorrect && (
                        <span className="option-feedback">Your answer</span>
                      )}
                    </label>
                  );
                })}
              </div>
            </fieldset>
          ))}
        </div>

        <div className="submit-row">
          <p>
            {attempted
              ? 'Only one attempt is allowed for this quiz in this browser.'
              : 'Your score is saved in this browser after submission.'}
          </p>
          <button className="submit-button" type="submit" disabled={attempted}>
            {attempted ? 'Attempt submitted' : 'Submit quiz'}
          </button>
        </div>
      </form>

      {result && (
        <div className="result-backdrop">
          <section
            className="result-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="result-title"
            aria-describedby="result-description"
          >
            <button
              className="result-close"
              type="button"
              aria-label="Close results"
              autoFocus
              onClick={() => setResult(null)}
            >
              &times;
            </button>
            <div className="result-icon" aria-hidden="true">✓</div>
            <span className="quiz-eyebrow">Quiz complete</span>
            <h2 id="result-title">Congratulations!</h2>
            <p id="result-description">You scored</p>
            <strong className="result-score">
              {result.score}<span> / {python_questions.length}</span>
            </strong>
            <p className="result-percentage">
              {Math.round((result.score / python_questions.length) * 100)}% correct
            </p>
            <p className="result-save-status" role="status">
              {result.saved
                ? 'Your score has been saved in this browser.'
                : 'We could not save your score. Please check your browser storage settings.'}
            </p>
            <button className="result-button" type="button" onClick={() => setResult(null)}>
              Back to questions
            </button>
          </section>
        </div>
      )}
    </main>
  );
};

export default TestSpace;